
import styled from "styled-components";

export const PageList = styled.div`
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
    flex-wrap: wrap;
`;

export const PageNotAnswered = styled.a`
    font-size: 0.5rem;
    background-color: #555;
    border-radius: 15px;
    padding: 5px 10px;
    margin: 5px;
    text-decoration: none;
    color: #ffffff;
    @media (min-width: 1000px) {
        font-size: 1rem;
        padding: 5px 15px;
    }
    &:focus {
        background: #fffee0;
        color: #000000;
    }
`;

export const PageAnswered = styled.a`
    font-size: 0.5rem;
    background-color: #aaa;
    border-radius: 15px;
    padding: 5px 10px;
    margin: 5px;
    text-decoration: none;
    color: #333333;
    @media (min-width: 1000px) {
        font-size: 1rem;
        padding: 5px 15px;
    }
    &:focus {
        background: #fffee0;
        color: #000000;
    }
`;

export const PageCurrent = styled.a`
    font-size: 0.5rem;
    background-color: #ddd;
    color: #000;
    border-radius: 15px;
    padding: 5px 10px;
    margin: 5px;
    text-decoration: none;
    color: #333333;
    @media (min-width: 1000px) {
        font-size: 1rem;
        padding: 5px 15px;
    }
    &:focus {
        background: #fffee0;
        color: #000000;
    }
`;



// WEBPACK FOOTER //
// ./src/Forms/reqol/ReqolFunctions.tsx